import { render, staticRenderFns } from "./orderNew.vue?vue&type=template&id=7c35cdc8&scoped=true&"
import script from "./orderNew.vue?vue&type=script&lang=js&"
export * from "./orderNew.vue?vue&type=script&lang=js&"
import style0 from "./orderNew.vue?vue&type=style&index=0&id=7c35cdc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35cdc8",
  null
  
)

export default component.exports